import React from 'react'
import PropTypes from 'prop-types'

import { getTimezone } from 'src/config/globals'
import LiveDate from 'src/components/LiveDate'
import { Grid, Flex, Box } from '@chatterbug/aaron'

const AppointmentTimeSlot = ({ startTime, endTime }) => {
  const timezone = getTimezone()

  return (
    <Grid
      columns={{ _: '1fr', tablet: '0.75fr 1fr' }}
      gridGap={{ _: 'none', tablet: '1x' }}
    >
      <Flex alignItems="center" as="p" variant="text.h5">
        <LiveDate date={startTime} format="cb_dddMMMD" timezone={timezone} />
      </Flex>
      <Flex
        alignItems="center"
        as="p"
        display={{ tablet: 'none' }}
        variant={'text.tinyTitle'}
      >
        <LiveDate date={startTime} format="cb_hmma" timezone={timezone} />
        <Box as="span" aria-hidden="true" px="0,25x">
          {'-'}
        </Box>
        <LiveDate date={endTime} format="cb_hmma" timezone={timezone} />
      </Flex>
      <Flex
        alignItems="center"
        display={{ _: 'none', tablet: 'flex' }}
        as="p"
        variant={'text.paragraph'}
      >
        <LiveDate date={startTime} format="cb_hmma" timezone={timezone} />
        <Box as="span" aria-hidden="true" px="0,25x">
          {'-'}
        </Box>
        <LiveDate date={endTime} format="cb_hmma" timezone={timezone} />
      </Flex>
    </Grid>
  )
}

AppointmentTimeSlot.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
}

export default AppointmentTimeSlot
